 const snowLayer = document.getElementById('snowLayer');
 const container = document.getElementById('logoContainer');
    
    // Config: Winter Colors
    const COLORS = ['#FFFFFF', '#E0F2FE', '#BAE6FD', '#F0F9FF', '#CBD5E1'];
    
    // Snowflake SVG
    const SNOW_SVG = (color) => `
      <svg viewBox="0 0 24 24" fill="${color}" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 11H14.414L16.707 8.707C17.0975 8.31653 17.0975 7.68337 16.707 7.29285C16.3165 6.90233 15.6834 6.90233 15.2929 7.29285L13 9.58575V3C13 2.44771 12.5523 2 12 2C11.4477 2 11 2.44771 11 3V9.58575L8.70711 7.29285C8.31658 6.90233 7.68342 6.90233 7.29289 7.29285C6.90237 7.68337 6.90237 8.31653 7.29289 8.707L9.58579 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H9.58579L7.29289 15.293C6.90237 15.6835 6.90237 16.3166 7.29289 16.7072C7.68342 17.0977 8.31658 17.0977 8.70711 16.7072L11 14.4142V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V14.4142L15.2929 16.7072C15.6834 17.0977 16.3165 17.0977 16.707 16.7072C17.0975 16.3166 17.0975 15.6835 16.707 15.293L14.414 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11Z" />
      </svg>
    `;

    // Helpers
    const random = (min, max) => Math.random() * (max - min) + min;
    const randomColor = () => COLORS[Math.floor(Math.random() * COLORS.length)];

    function createSnowflake() {
      const el = document.createElement('div');
      el.classList.add('snowflake');
      
      // Randomize Physics
      // Logo Width Area (-140 to 140 is roughly the visual width of the logo)
      const startX = random(-100, 100);
      const startY = random(-30, 30);
      
      // Drift Logic
      const angle = random(0, 360);
      const dist = random(20, 50); 
      const radian = (angle * Math.PI) / 180;
      const endX = startX + Math.cos(radian) * dist;
      const endY = startY + Math.sin(radian) * dist;
      
      const size = random(8, 18);
      const duration = random(2.5, 5.0);
      const delay = random(0, 0.5);
      const rotation = random(0, 360);
      const color = randomColor();

      // Apply CSS Variables
      el.style.setProperty('--sx', `${startX}px`);
      el.style.setProperty('--sy', `${startY}px`);
      el.style.setProperty('--tx', `${endX}px`);
      el.style.setProperty('--ty', `${endY}px`);
      el.style.setProperty('--rot', `${rotation}deg`);
      el.style.setProperty('--dur', `${duration}s`);
      el.style.setProperty('--delay', `${delay}s`);
      el.style.width = `${size}px`;
      el.style.height = `${size}px`;
      
      el.innerHTML = SNOW_SVG(color);
      
      snowLayer.appendChild(el);

      // Cleanup DOM element after animation finishes
      setTimeout(() => {
        el.remove();
      }, (duration + delay) * 1000);
    }

    function addSnowflakes(count) {
      for (let i = 0; i < count; i++) {
        createSnowflake();
      }
    }

    // Continuous Background Snow
    setInterval(() => {
      addSnowflakes(random(3, 6)); 
    }, 400);

    // Burst Effect on Hover
    container.addEventListener('mouseenter', () => {
      addSnowflakes(40);
    });